export default class MessageNodeConst {
    static VAR_MSG_IN='variableMsgInput';
    static VAR_MSGTYPE_IN='variableMsgInputType';
    static VAR_MSGMODAL_IN='variableMsgModalInput';
    
  }

  